import {
  ChevronLeft,
  ChevronRight,
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
import {
  Box,
  ClickAwayListener,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import clsx from "clsx";
import React, { Fragment, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import { sidebarOptions } from "./menu";
import { useStyles } from "./styles";
import { useSelector } from "react-redux";

export default function Sidebar({ open, setOpen }) {
  const classes = useStyles();
  let location = useLocation();
  const [expanded, setExpanded] = useState("");
  const loggedUser = useSelector(state => state?.users?.loggedUser?.result)


  const handleNested = (menuItem) => {
    setOpen(true);
    if (expanded === menuItem && open) {
      setExpanded("");
    } else {
      setExpanded(menuItem);
    }
  };

  const renderListItemDetails = (item, nested = false) => (
    <ListItemButton
      classes={{
        selected: classes.selectedItem,
      }}
      selected={`/${location.pathname.split("/")[1]}` === item.path}
      sx={{
        minHeight: 48,
        justifyContent: open ? "initial" : "center",
        px: 1,
      }}
      onClick={() => setOpen(false)}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          mr: open ? 1 : "auto",
          justifyContent: "center",
        }}
      >
        {item.Icon}
      </ListItemIcon>
      <ListItemText
        primary={item.label}
        sx={{
          opacity: open ? 1 : 0,
          "& .MuiTypography-root": {
            fontSize: "14px",
          },
        }}
      />
    </ListItemButton>
  );

  const renderMenuItems = (item, hasAccess, nested = false) => {
    return hasAccess && (
      <Tooltip
        key={`${item.label}-tooltip`}
        title={!open ? item.label : ""}
        placement="right"
      >
        <ListItem
          className={classes.itemList}
          disablePadding
          component={NavLink}
          to={item.path}
          key={item.label}
          sx={{
            width: nested ? "93%" : "100%",
            ml: nested ? "16px !important" : 0,
          }}
        >
          {renderListItemDetails(item, nested)}
        </ListItem>
      </Tooltip>
    );
  };

  const renderSubMenu = (item, hasAccess) => {
    return hasAccess &&   (
      <Fragment key={`${item.label}-tooltip`}>
        <Tooltip title={!open ? item.label : ""} placement="right">
          <ListItem
            onClick={() => handleNested(item.label)}
            className={classes.itemList}
            disablePadding
            key={item.label}
          >
            {renderListItemDetails(item)}
            {open &&
              (expanded === item.label ? <ExpandLess /> : <ExpandMore />)}
          </ListItem>
        </Tooltip>
        <Collapse
          in={open && expanded === item.label}
          timeout="auto"
          unmountOnExit
        >
          {item.subMenu.map((item) => renderMenuItems(item, hasAccess, true))}
        </Collapse>
      </Fragment>
    );
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx(classes.root, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <Box className={classes.header} onClick={() => setOpen(!open)}>
          <span
            className={classes.imageView}
            style={{ display: open ? "flex" : "none" }}
          >
            <img src={Logo} alt="logo" />
            <span>IaC Controller</span>
          </span>
          <IconButton size="small" className={classes.list}>
            {open ? <ChevronLeft /> : <ChevronRight />}
          </IconButton>
        </Box>
        <List style={{ padding: "0px 12px" }}>
          {sidebarOptions.map((item) => {
            const { subMenu = [], roles : featureRoles } = item;
            const hasAccess = loggedUser?.roles?.some(role => featureRoles?.includes(role))
            return !subMenu?.length 
              ? renderMenuItems(item, hasAccess)
              : renderSubMenu(item, hasAccess);
          })}
        </List>
      </Drawer>
    </ClickAwayListener>
  );
}
